<template>
    <div>
        <md-card id="cardSchedule">
            <md-card-content>
                <md-list>
                    <md-list-item v-for="schedule in seasonSchedules" :key="schedule.id">
                        <span class="md-list-item-text">{{schedule.n}}</span>
                        <md-button class="md-icon-button md-accent" @click="showScheduleInfo(schedule.id)">
                            <md-icon>more_horiz</md-icon>
                        </md-button>
                    </md-list-item>
                </md-list>
            </md-card-content>
            <md-card-actions>
                <md-button class="md-icon-button md-accent" @click="showScheduleImportExportDialog = true">
                    <md-icon>import_export</md-icon>
                </md-button>
                <md-button class="md-icon-button md-accent" @click="addSchedule()">
                    <md-icon>add_circle</md-icon>
                </md-button>
            </md-card-actions>
        </md-card>
        <md-dialog class="scheduleInfoInputDialog" :md-active.sync="showScheduleInfoDialog" id="scheduleInfoInputDialog">
            <md-dialog-title>Schedule Info</md-dialog-title>
            <md-dialog-content>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-95">
                        <md-field>
                            <label>Name</label>
                            <md-input v-model="scheduleInfoTemp.n" v-on:change="scheduleChanged('n', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-95">
                        <span>Buy In</span>
                    </div>
                    <div class="md-layout-item md-size-20">
                        <md-field>
                            <label>Chips</label>
                            <md-input v-model.number="scheduleInfoTemp.bc" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('bc', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-45">
                        <md-field>
                            <label>Cost including Year End</label>
                            <span class="md-prefix">$</span>
                            <md-input v-model.number="scheduleInfoTemp.bt" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('bt', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-35">
                        <md-field>
                            <label>Year End Portion</label>
                            <span class="md-prefix">$</span>
                            <md-input v-model.number="scheduleInfoTemp.by" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('by', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-95">
                        <span>Rebuy</span>
                    </div>
                    <div class="md-layout-item md-size-20">
                        <md-field>
                            <label>Chips</label>
                            <md-input v-model.number="scheduleInfoTemp.rc" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('rc', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-45">
                        <md-field>
                            <label>Cost including Year End</label>
                            <span class="md-prefix">$</span>
                            <md-input v-model.number="scheduleInfoTemp.rt" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('rt', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-35">
                        <md-field>
                            <label>Year End Portion</label>
                            <span class="md-prefix">$</span>
                            <md-input v-model.number="scheduleInfoTemp.ry" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('ry', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-95">
                        <span>Topup</span>
                    </div>
                    <div class="md-layout-item md-size-20">
                        <md-field>
                            <label>Chips</label>
                            <md-input v-model.number="scheduleInfoTemp.tc" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('tc', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-45">
                        <md-field>
                            <label>Cost including Year End</label>
                            <span class="md-prefix">$</span>
                            <md-input v-model.number="scheduleInfoTemp.tt" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('tt', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-35">
                        <md-field>
                            <label>Year End Portion</label>
                            <span class="md-prefix">$</span>
                            <md-input v-model.number="scheduleInfoTemp.ty" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('ty', $event)"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-100">
                        <span>Levels</span>
                        <md-divider></md-divider>
                    </div>
                </div>

                <draggable :list="seasonScheduleLevels" :options="{handle: '.handle'}">
                    <div class="md-layout md-gutter" v-for="(level, index) in seasonScheduleLevels" :key="index" :id="'level-' + index" :name="'level-' + index">
                        <div class="md-layout-item md-size-5 offset-left-10">
                            <md-icon class="handle md-accent">reorder</md-icon>
                        </div>
                        <div class="md-layout-item md-size-5 offset-left-10">
                            <span class="scheduleLevelTimeSubtotal">{{incrementSubTotal(index)}}</span>
                        </div>
                        <div class="md-layout-item md-size-25 offset-left-10">
                            <md-field>
                                <label :for="'t-' + index">Type</label>
                                <md-select v-model="level.t" :name="'t-' + index" :id="'t-' + index" v-on:md-selected="scheduleChanged('t-' + index, $event)">
                                    <md-option :value="blindLevelTypes.blind">Blind</md-option>
                                    <md-option :value="blindLevelTypes.break">Break</md-option>
                                </md-select>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-15 offset-left-10">
                            <md-field>
                                <label>Minutes</label>
                                <md-input v-model.number="level.m" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('m-' + index, $event)"></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-25 offset-left-10">
                            <md-field v-if="level.t === blindLevelTypes.blind">
                                <label>Small Blind</label>
                                <md-input v-model.number="level.s" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('s-' + index, $event)"></md-input>
                            </md-field>
                            <md-field v-if="level.t === blindLevelTypes.break">
                                <label>Colour From</label>
                                <md-input v-model.number="level.cf" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('cf-' + index, $event)"></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-20 offset-left-10">
                            <md-field v-if="level.t === blindLevelTypes.blind">
                                <label>Big Blind</label>
                                <md-input v-model.number="level.b" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('b-' + index, $event)"></md-input>
                            </md-field>
                            <md-field v-if="level.t === blindLevelTypes.break">
                                <label>Colour To</label>
                                <md-input v-model.number="level.ct" type="number" class="scheduleInfoInput" v-on:change="scheduleChanged('ct-' + index, $event)"></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item alignLevelButton md-size-5 offset-left-10">
                            <md-menu md-size="small" :md-offset-x="40" :md-offset-y="-102" md-close-on-click>
                                <md-button class="md-icon-button md-accent" md-menu-trigger>
                                    <md-icon>more_vert</md-icon>
                                </md-button>
                                <md-menu-content>
                                    <md-menu-item class="md-accent" @click="levelInsertBefore(level)">Insert Before</md-menu-item>
                                    <md-menu-item class="md-accent" @click="levelDelete(level)">Delete</md-menu-item>
                                    <md-menu-item class="md-accent" @click="levelInsertAfter(level)">Insert After</md-menu-item>
                                </md-menu-content>
                            </md-menu>
                        </div>
                    </div>
                </draggable>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-accent" @click="deleteSchedule()">Delete</md-button>
                <md-button class="md-accent" @click="showScheduleInfoDialog = false">Close</md-button>
                <md-button class="md-accent" @click="updateScheduleInfo()">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog class="scheduleInfoInputDialog" :md-active.sync="showScheduleImportExportDialog" id="scheduleInfoImportExportDialog">
            <md-dialog-title>Schedule Import/Export</md-dialog-title>
            <md-dialog-content>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-100">
                        <md-radio v-model="importExportType" value="0">Import from previous season</md-radio>
                        <md-radio v-model="importExportType" value="1">Import from file</md-radio>
                        <!--<md-radio v-model="importExportType" value="2">Export to file</md-radio>-->
                    </div>
                    <div class="md-layout-item md-size-45" :class="{'importExportHidden': importExportType !== '0'}">
                        <md-field>
                            <label for="selectSeason">Select Season:</label>
                            <md-select v-model="importSeasonId" name="selectSeason" id="selectSeason" @md-selected="selectSeason">
                                <md-option v-for="season in importSeasons" :key="season.id" :value="season.id">{{season.n}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div clss="md-layout-item md-size-45" :class="{'importExportHidden': importExportType !== '0'}">
                        <md-field v-if="!(importSeasonId < 0)">
                            <label for="selectSchedule">Select Schedule:</label>
                            <md-select v-model="importScheduleId" name="selectSchedule" id="selectSchedule">
                                <md-option v-for="schedule in importScheduleList" :key="schedule.id" :value="schedule.id">{{schedule.n}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div clss="md-layout-item md-size-10" :class="{'importExportHidden': importExportType !== '0'}">
                        <md-button class="md-icon-button md-accent" v-if="!(importScheduleId < 0)" @click="importSchedule">
                            <md-icon>add_circle</md-icon>
                        </md-button>
                    </div>
                </div>
            </md-dialog-content>
            <md-dialog-actions>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import { Duration } from 'luxon'
import { mapState, mapGetters, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import { blindLevelTypes } from '../constants.js'

var timeSubTotal = 0
const blankLevel = '{"t": 0}'

export default {
  name: 'SeasonSchedules',
  props: {currentSeason: Object},
  data: function () {
    return {
      showScheduleInfoDialog: false,
      showScheduleImportExportDialog: false,
      showAddScheduleDialog: false,
      scheduleInfoTemp: {},
      seasonScheduleLevels: [],
      importExportType: '0',
      bypass: false,
      blindLevelTypes: blindLevelTypes,
      importSeasonId: -1,
      importScheduleList: [],
      importScheduleId: -1
    }
  },
  components: {
    draggable
  },
  created: function () {
    if (this.activeSeasonId === -1) {
      this.bypass = true
      if (!this.$route.path.toLowerCase().startsWith('/season/settings')) {
        this.$router.push('/season/settings')
      }
    }
  },
  computed: {
    ...mapState(['seasonSchedules', 'activeSeasonId', 'seasons']),
    ...mapGetters(['scheduleById']),
    importSeasons: function () {
      let seasons = []
      for (let i = 0; i < this.seasons.length; i++) {
        const season = this.seasons[i]
        if (season.id !== this.activeSeasonId) {
          seasons.push(season)
        }
      }
      return seasons
    }
  },
  methods: {
    ...mapActions(['displayError']),
    showScheduleInfo: function (scheduleId) {
      this.$store.dispatch('getScheduleLevels', scheduleId).then((levels) => {
        this.scheduleInfoTemp = JSON.parse(JSON.stringify(this.scheduleById(scheduleId)))
        this.seasonScheduleLevels.id = scheduleId
        this.seasonScheduleLevels = levels
        this.scheduleInfoTemp.deletedLevels = []
        this.scheduleInfoTemp.updates = {}
        this.scheduleInfoTemp.updatedLevels = {}
        this.scheduleInfoTemp.addedLevels = []
        this.showScheduleInfoDialog = true
      }).catch((err) => {
        this.displayError('Error getting schedule: ' + err.message)
      })
    },
    levelInsertBefore: function (level) {
      var index = this.seasonScheduleLevels.indexOf(level)
      this.seasonScheduleLevels.splice(index, 0, JSON.parse(blankLevel))
    },
    levelInsertAfter: function (level) {
      var index = this.seasonScheduleLevels.indexOf(level)
      this.seasonScheduleLevels.splice(index + 1, 0, JSON.parse(blankLevel))
    },
    levelDelete: function (level) {
      var index = this.seasonScheduleLevels.indexOf(level)
      if (level.hasOwnProperty('id')) {
        this.scheduleInfoTemp.deletedLevels.push(level.id)
      }
      if (this.seasonScheduleLevels.length === 1) {
        this.seasonScheduleLevels.splice(0, 1, JSON.parse(blankLevel))
      } else {
        this.seasonScheduleLevels.splice(index, 1)
      }
    },
    updateScheduleInfo: function () {
      var scheduleId = -1
      for (let index = 0; index < this.seasonScheduleLevels.length; index++) {
        let level = this.seasonScheduleLevels[index]
        if (level.hasOwnProperty('id')) {
          if (level.o !== index) {
            level.o = index
            this.scheduleChanged('o-' + index, index)
          }
        } else {
          level.o = index
          this.scheduleInfoTemp.addedLevels.push(level)
        }
      }
      if (this.scheduleInfoTemp.hasOwnProperty('id')) {
        scheduleId = this.scheduleInfoTemp.id
      }

      let seasonScheduleUpdates = {
        scheduleId: scheduleId,
        scheduleUpdated: this.scheduleInfoTemp.updates,
        levelsUpdated: this.scheduleInfoTemp.updatedLevels,
        levelsAdded: this.scheduleInfoTemp.addedLevels,
        levelsDeleted: this.scheduleInfoTemp.deletedLevels
      }

      this.$store.dispatch('seasonScheduleUpdated', seasonScheduleUpdates).then(() => {
        this.showScheduleInfoDialog = false
      })
    },
    deleteSchedule: function () {
      if (this.scheduleInfoTemp.id !== -1) {
        this.$store.dispatch('seasonScheduleDelete', {scheduleId: this.scheduleInfoTemp.id})
      }
      this.showScheduleInfoDialog = false
    },
    addSchedule: function () {
      this.scheduleInfoTemp = {}
      this.scheduleInfoTemp.id = -1
      this.seasonScheduleLevels = []
      this.seasonScheduleLevels.splice(0, 0, JSON.parse(blankLevel))
      this.scheduleInfoTemp.deletedLevels = []
      this.scheduleInfoTemp.updates = {}
      this.scheduleInfoTemp.updatedLevels = {}
      this.scheduleInfoTemp.addedLevels = []
      this.showScheduleInfoDialog = true
    },
    incrementSubTotal: function (index) {
      var levelSubtotal = ''
      if (index === 0) {
        timeSubTotal = 0
      }

      if (this.seasonScheduleLevels[index].m > 0) {
        timeSubTotal += this.seasonScheduleLevels[index].m
      }

      levelSubtotal = Duration.fromObject({minutes: timeSubTotal}).toFormat('hh:mm')
      return levelSubtotal
    },
    scheduleChanged: function (propertyChanged, event) {
      let changes = propertyChanged.split('-')
      var currentValue = null
      if (changes[0] === 't' || changes[0] === 'o') {
        currentValue = parseInt(event)
      } else {
        if (changes[0] === 'n') {
          currentValue = event.currentTarget.value.toString()
        } else {
          currentValue = parseInt(event.currentTarget.value)
        }
      }
      if (changes.length > 1) {
        if (this.seasonScheduleLevels[parseInt(changes[1])].hasOwnProperty('id')) {
          let changedKey = this.seasonScheduleLevels[parseInt(changes[1])].id.toString()
          if (!this.scheduleInfoTemp.updatedLevels.hasOwnProperty(changedKey)) {
            this.scheduleInfoTemp.updatedLevels[changedKey] = {}
          }
          this.scheduleInfoTemp.updatedLevels[changedKey][changes[0]] = currentValue
        }
      } else {
        this.scheduleInfoTemp.updates[changes[0]] = currentValue
      }
    },
    selectSeason: function (val) {
      if (!(val <= 0)) {
        this.$store.dispatch('getSeasonSchedules', val).then((scheduleList) => {
          this.importScheduleList = scheduleList
        })
      }
    },
    importSchedule: function () {
      if (!(this.importScheduleId <= 0)) {
        this.$store.dispatch('getSchedule', {seasonId: this.importSeasonId, scheduleId: this.importScheduleId}).then((schedule) => {
          delete schedule['id']
          this.$store.dispatch('importNewSchedule', {seasonId: this.activeSeasonId, schedule: schedule}).then((scheduleId) => {
            this.showScheduleImportExportDialog = false
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .md-menu-content {
    z-index: 11;
  }
  .scheduleInfoInput {
    width: 100%;
  }
  .scheduleLevelTimeSubtotal {
    position: relative;
    top: 58px;
    left: -15px;
   }
  .md-card {
      width: 250px;
  }
  .handle {
      position: relative;
      top: 20px;
      left: -5px;
  }
  .md-layout.md-gutter>.md-layout-item {
    padding-right: 2px;
    padding-left: 2px;
  }
  .offset-left-10 {
    position: relative;
    left: -10px;
  }
  .md-field label {
      font-size: 12px;
  }
  .importExportHidden {
    display: none;
  }
</style>
